import React from "react";
import { NavLink } from "react-router-dom";
import CIcon from "@coreui/icons-react";
import { cilSpeedometer, cilRestaurant, cilLayers, cilChartLine, cilChatBubble } from "@coreui/icons";
import "./mobileBottomNav.css";

const ITEMS = [
  { to: "/dashboard", icon: cilSpeedometer, label: "Дашборд" },
  { to: "/menu-engineering", icon: cilRestaurant, label: "Меню" },
  { to: "/warehouse", icon: cilLayers, label: "Склад" },
  { to: "/forecast", icon: cilChartLine, label: "Прогноз" },
  { to: "/assistant", icon: cilChatBubble, label: "AI" },
];

/** Visible only below the md breakpoint (CSS-driven, no JS viewport check needed). */
export default function MobileBottomNav() {
  return (
    <nav className="dash-mobile-nav d-md-none">
      {ITEMS.map((item) => (
        <NavLink
          key={item.to}
          to={item.to}
          className={({ isActive }) => `dash-mobile-nav-item${isActive ? " active" : ""}`}
        >
          <CIcon icon={item.icon} size="lg" />
          <span>{item.label}</span>
        </NavLink>
      ))}
    </nav>
  );
}
